import { render, staticRenderFns } from "./ComprobantesPendientesDeVendedores.vue?vue&type=template&id=fa9168f0&"
import script from "./ComprobantesPendientesDeVendedores.vue?vue&type=script&lang=js&"
export * from "./ComprobantesPendientesDeVendedores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports